import { TextFont, TextInfo, TextOption } from '../../../../components/pages/layout/toolbar/layout.free-text';
import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { TrimDataManager } from '../../data/trim-data.manager';
import { TrimCjContainer, TrimCjShape, TrimCjText } from '../../../model/cj-factory';
import { TrimCjShadow } from '../../../model/cj-factory/trim.cj-shadow';
import { TrimCjGraphics } from '../../../model/cj-factory/trim.cj-graphics';
import { TextFontStyle, TrimTextEvent } from './trim.text-event';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME } from '../../../model/cj-factory/trim.cj-obj-name.collection';
import { TrimEditableEvent } from '../trim.editable-event';
import { TrimCjTool } from '../../../../utilities/trim.cj-tool';
import { UuidGenerator } from '../../../../utilities/uuid-generator';
import { TrimPosManager } from '../../pos/trim.pos.manager';
import { TrimImageEditManager } from '../trim.image-edit.manager';
import { OrderPageDataXml } from '../../../../xml/class/order/order-page-data-xml';
import { TrimUiManager } from '../../ui/trim.ui.manager';
import { dialogActions } from '../../../../components/dialog/slice/dialog-slice';
import { store } from '../../../../app/store';
import {
  LocalFontLoaderErrorDialog,
} from '../../../../components/pages/layout/toolbar/layout.local-font-loader-error-dialog';
import { layoutActions } from '../../../../slices/layout-slice';
import { ColorCodeConverter } from '../../../../utilities/colorcode-converter';
import { TrimPrintManager } from '../../../print/trim.print';
import PixelConverter from '../../../../utilities/pixel-converter';
import { TrimTextDataEntity } from '../../../model/trim.print-model';
import { trimActions } from '../../../../slices/trim-slice';

type TextType = {
  id: string,
  text: string,
  y: number,
  x: number,
}

export type TrimTextAlignCodeType = '0' | '1' | '2';
export type TrimTextAlignStrType = 'left' | 'right' | 'center';

export type TextEditType = {
  id: string,
  text: string,
  color: string,
  alpha: number,
  rotation: number,
  textAlign: TrimTextAlignStrType,
  lineHeight: number,
  font: TextFont,
  options: TextOption,
}

export class TrimTextController {
  private stage: TrimCjContainer;
  private readonly pageId: string;
  // public orderPage?: OrderPageDataXml;

  private textEvent!: TrimTextEvent;
  private trimDataManager!: TrimDataManager;
  private editableEvent!: TrimEditableEvent;
  private posManager!: TrimPosManager;
  private printManager!: TrimPrintManager;
  private imageEditManager!: TrimImageEditManager;

  private textData: TextType = {
    id: '',
    text: '',
    y: 0,
    x: 0,
  };

  fontType: '' | 'local' | 'server' = 'server';

  // textContainer?: TrimCjContainer;
  // textImage?: TrimCjText;
  backupText?: TrimCjText;
  backupTextContainer?: TrimCjContainer;
  outlineData?: TrimCjText;
  shadow?: TrimCjShadow;

  textMode: 'add' | 'reload' = 'add';
  textBox: TrimCjContainer[] = [];

  constructor(stage: TrimCjContainer, pageId: string) {
    this.stage = stage;
    this.pageId = pageId;
  }

  di(
    textEvent: TrimTextEvent,
    layoutDataManager: TrimDataManager,
    editableEvent: TrimEditableEvent,
    posManager: TrimPosManager,
    printMng: TrimPrintManager,
    imageEditMng: TrimImageEditManager,
  ): void {
    this.textEvent = textEvent;
    this.trimDataManager = layoutDataManager;
    this.editableEvent = editableEvent;
    this.posManager = posManager;
    this.printManager = printMng;
    this.imageEditManager = imageEditMng;
  }

  initialize(): void {
  }

  destroy(): void {
    this.textData = { id: '', text: '', x: 0, y: 0 };
    this.fontType = 'server';
    // this.textContainer = undefined;
    // this.textImage = undefined;
    this.backupText = undefined;
    this.backupTextContainer = undefined;
    this.outlineData = undefined;
    this.shadow = undefined;
    this.textMode = 'add';
    this.textBox = [];
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  textAlignFormat(textAlign: TrimTextAlignStrType) {
    switch (textAlign) {
      case 'left':
        return '0';
      case 'center':
        return '1';
      case 'right':
        return '2';
      default:
        return null;
    }
  };

  getTextAlign = (textAlign: TrimTextAlignCodeType) => {
    switch (textAlign) {
      case '0':
        return 'left';
      case '1':
        return 'center';
      case '2':
        return 'right';
      default:
        return 'left';
    }
  };

  // - テキストモード -
  insertText(e: any, callback: (isOpen: boolean, info: TextInfo) => void) {
    const pos = this.posManager.browserToCanvas({
      x: e.stageX - TrimImageEditManager.STAGE_CONTAINER_X,
      y: e.stageY - TrimImageEditManager.STAGE_CONTAINER_Y,
    });
    this.textData.y = pos.y;
    this.textData.x = pos.x;
    const textId = `text:${UuidGenerator.create()}`;
    this.addText(textId).then((res) => {
      callback(
        true,
        {
          id: res.textId ?? '',
          isBold: false,
          isItalic: false,
          textColor: '#808080',
          isOnDropper: false,
          fontType: 'server',
          font: '0',
          fontSize: '24',
          textTransparency: 100,
          dropShadow: false,
          transparency: 65,
          distance: 7,
          outlineWidth: 0,
          outlineColor: '#ff0000',
          textAlign: '0',
          textRotation: 0,
          textSelectRotation: 0,
          lineSpacingNum: 1,
          textAreaContents: '',
          height: 0,
        });
    });
    document.body.style.cursor = '';
    // this.fbCanvas?.off('mouse:up')
  }

  // - テキストの挿入 -
  async addText(textId: string, isDate?: boolean) {
    return new Promise<TrimCjContainer>((resolve) => {
      // await new Promise<void>((resolve) => {
      const newText = new TrimCjText();
      newText.set({
        textId,
        // y: this.textData.y,
        // x: this.textData.x,
        name: isDate ? CJ_DPOBJ_NAME.dateText : CJ_DPOBJ_NAME.text,
        originPos: {
          y: this.textData.y,
          x: this.textData.x,
        },
      });
      // フォント読み込み用遅延
      setTimeout(() => {
        const textContainer = new TrimCjContainer(this.pageId, undefined, undefined, undefined, newText.textId);
        textContainer.name = isDate ? CJ_CONTAINER_NAME.dateText : CJ_CONTAINER_NAME.text;
        textContainer.addChild(newText);
        // textContainer.mouseEnabled = false;
        textContainer.set({
          y: this.textData.y,
          x: this.textData.x,
        });
        // this.textImage = newText;
        // this.textEvent.setFocus(textContainer);
        // this.textEvent.setTextEvent(newText, textContainer);
        this.stage.addChild(textContainer);
        this.trimDataManager.setText(textContainer);
        this.backupText = cloneDeep(newText);
        this.backupTextContainer = cloneDeep(textContainer);
        this.textBox.push(textContainer);
        resolve(textContainer);
      });
    });
  }

  // FIXME: Undo時に最終的にはテキストを消す。アウトラインとシャドウ併用時挙動に不具合あり
  // - テキストの挿入 -
  async editText( editPram: TextEditType, backupText: TrimCjText, isRestore?: boolean, isDateText?: boolean, callback?: () => void) {
    const {font, id, text: _text, textAlign, options, color, rotation, lineHeight, alpha} = editPram;
    const textContainer = this.trimDataManager.getText(id);
    const pxSize = PixelConverter.ptToPx(Number(font.size.replace('pt', ''))) / TrimDataManager.getAdditionalValue + 'px';
    if (!textContainer) return;
    const textData = isDateText ? TrimCjTool.getDateText(textContainer as TrimCjContainer) : TrimCjTool.getText(textContainer as TrimCjContainer);
    if (!textData) return;
    const step = textData.text ? 'edit' : 'create';
    const lines = TrimTextEvent.splitByNewline(_text);
    const text = TrimTextEvent.normalizeToCRLF(lines);
    // -- テキスト装飾 --
    textData.fontData = font;
    textData.options = options;
    textData.font = `${font.isBold} ${font.isItalic} ${pxSize} ${font.family}`.trim();
    textData.text = text;
    textContainer.text = text;
    textData.alpha = alpha;
    textContainer.rotation = rotation;
    textData.color = color;
    textContainer.fontColor = color;
    textData.textAlign = textAlign;
    // textData.lineHeight = textBounds.height + Number(lineHeight);
    const _font: TextFontStyle = {
      isBold: font.isBold,
      isItalic: font.isItalic,
      family: font.family,
      size: pxSize,
      outline: options.outline
    }
    const textBounds = TrimTextEvent.measure(textData.getTransformedBounds(), _font, text);
    textData.lineHeight = (TrimTextEvent.getLineHeight(_font) ?? textData.getMeasuredLineHeight());
    const _textBounds = textData.getBounds();
    switch (textAlign) {
      case 'center':
        textData.x = _textBounds.width / 2;
        textData.margin = _textBounds.width / 2;
        break;
      case 'right':
        textData.x = _textBounds.width;
        textData.margin = _textBounds.width;
        break;
      default:
        textData.x = 0;
        textData.margin = 0;
        break;
    }
    // -- アウトライン設定時は複製して重ねる --
    if (options.outline) {
      if (TrimCjTool.checkOutline(textContainer)) {
        const prevOutline = TrimCjTool.getOutline(textContainer);
        textContainer.removeChild(prevOutline);
      }
      const outlineText = textData.clone();
      outlineText.mouseEnabled = false;
      outlineText.name = CJ_DPOBJ_NAME.outline;
      outlineText.outline = Number(options.outline);
      outlineText.color = options.outlineColor;
      textContainer.addChild(outlineText);
      textContainer.setChildIndex(textData, textContainer.numChildren - 1);

      if (options.isShadow) {
        this.shadow = new TrimCjShadow(options.shadowTransparency, Number(options.offset), Number(options.offset), 0);
        outlineText.shadow = this.shadow;
      } else {
        (outlineText.shadow as createjs.Shadow | null) = null;
      }

    } else {
      if (TrimCjTool.checkOutline(textContainer)) {
        const prevOutline = TrimCjTool.getOutline(textContainer);
        textContainer.removeChild(prevOutline);
      }
    }
    // if (options.isShadow) {
    //   this.shadow = new TrimCjShadow(options.shadowTransparency, Number(options.offset), Number(options.offset), 0);
    //   textData.shadow = this.shadow;
    // } else {
    //   (textData.shadow as createjs.Shadow | null) = null;
    // }
    // textContainer.rotation = rotation;
    const textTfBounds = textData.getTransformedBounds();
    const hitArea = new TrimCjShape();
    hitArea.set({
      x: hitArea.x,
      y: hitArea.y,
      graphics: new TrimCjGraphics().f('#FFFFFF').dr(-(textData.margin), 0, textTfBounds.width, textTfBounds.height),
    });
    textData!.hitArea = hitArea;
    this.fontType = options.fontType;
    if (step === 'create') {
      if (isDateText) {
        this.stage.addChild(textContainer);
        // - 位置を見た目上いい感じにするための調整 -
        // textContainer.x = this.imageEditManager.templateBaseVirtual.w - (textBounds.width * 1.3)
        // textContainer.y = this.imageEditManager.templateBaseVirtual.h - (textBounds.height + textBounds.width * 0.3)
        textContainer.fontName = font.family;
        textContainer.bold = font.isBold;
        textContainer.italic = font.isItalic;
        textContainer.textSize = pxSize;
        textContainer.horizontalAlignment = this.textAlignFormat(textAlign);
        textContainer.borderSize = String(options.outline);
        textContainer.borderColor = options.outlineColor;
        textContainer.rotation = rotation;
        textContainer.dropShadow = {
          enable: options.isShadow,
          transparence: options.shadowTransparency,
          virtualSize: Number(options.offset),
        };
        this.trimDataManager.setText(textContainer);
        const itemData = this.printManager.currentPrint?.item.images.find(v => v.id === this.printManager.editableImageId);
        if (!itemData || !itemData?.datePrint) {
          textContainer.visible = false;
        }
        return;
      }
      this.textEvent.setFocus(textContainer, !!isRestore, () => {
        this.textEvent.setTextEvent(textData, textContainer);
        this.editableEvent.action(
          'addText',
          `テキストを追加。`,
          () => {
            this.stage.addChild(textContainer);
            textContainer.fontName = font.family;
            textContainer.bold = font.isBold;
            textContainer.italic = font.isItalic;
            textContainer.textSize = pxSize;
            textContainer.horizontalAlignment = this.textAlignFormat(textAlign);
            textContainer.borderSize = String(options.outline);
            textContainer.borderColor = options.outlineColor;
            textContainer.rotation = rotation;
            textContainer.dropShadow = {
              enable: options.isShadow,
              transparence: options.shadowTransparency,
              virtualSize: Number(options.offset),
            };
            this.textEvent.updateFocus(textContainer);
            this.trimDataManager.setText(textContainer)
          },
          () => {
            this.stage.removeChild(textContainer!);
            this.textBox = this.textBox.filter(v => v.textId !== textContainer.textId);
            this.trimDataManager.removeText(textContainer.textId ?? '');
          },
        );
        callback?.();
      });
    } else {
      if (!textData || !textContainer) return;
      textData.fontData = font;
      textData.options = options;
      textData.font = `${font.isBold} ${font.isItalic} ${pxSize} ${font.family}`.trim();
      textContainer.fontName = font.family;
      textContainer.bold = font.isBold;
      textContainer.italic = font.isItalic;
      textContainer.textSize = pxSize;
      textContainer.text = text;
      textData.text = text;
      textData.alpha = alpha;
      textContainer.rotation = rotation;
      textData.color = color;
      textContainer.fontColor = color;
      textData.textAlign = textAlign;
      textContainer.horizontalAlignment = this.textAlignFormat(textAlign);
      textData.lineHeight = (TrimTextEvent.getLineHeight(_font) ?? textData.getMeasuredLineHeight());
      textContainer.lineHeight = String(lineHeight);
      // -- アウトライン設定時は複製して重ねる --
      if (options.outline) {
        if (TrimCjTool.checkOutline(textContainer)) {
          const prevOutline = TrimCjTool.getOutline(textContainer);
          textContainer.removeChild(prevOutline);
        }
        const outlineText = textData.clone();
        outlineText.mouseEnabled = false;
        outlineText.name = CJ_DPOBJ_NAME.outline;
        outlineText.outline = options.outline;
        textContainer.borderSize = String(options.outline);
        outlineText.color = options.outlineColor;
        textContainer.borderColor = options.outlineColor;
        textContainer.addChild(outlineText);
        textContainer.setChildIndex(textData, textContainer.numChildren - 1);
      } else {
        if (TrimCjTool.checkOutline(textContainer)) {
          const prevOutline = TrimCjTool.getOutline(textContainer);
          textContainer.removeChild(prevOutline);
        }
        textContainer.borderSize = String(options.outline);
        textContainer.borderColor = options.outlineColor;
      }
      // if (options.isShadow) {
      //   textContainer.dropShadow = {
      //     enable: options.isShadow,
      //     transparence: options.shadowTransparency,
      //     virtualSize: options.offset,
      //   };
      //   this.shadow = new TrimCjShadow(options.shadowTransparency, options.offset, options.offset, 0);
      //   textData.shadow = this.shadow;
      // } else {
      //   (textData.shadow as createjs.Shadow | null) = null;
      //   textContainer.dropShadow = {
      //     enable: false,
      //     transparence: 'rgba(0,0,0,0.65)',
      //     virtualSize: 7,
      //   };
      // }
      const textTfBounds = textData.getTransformedBounds();
      const hitArea = new TrimCjShape();
      hitArea.set({
        x: hitArea.x,
        y: hitArea.y,
        graphics: new TrimCjGraphics().f('#FFFFFF').dr(-(textData.margin), 0, textTfBounds.width, textTfBounds.height),
      });
      textData.hitArea = hitArea;
      this.fontType = options.fontType;
      console.log(textContainer);
      this.textEvent.updateFocus(textContainer);
      this.trimDataManager.setText(textContainer);
    }
  }

  finishTextEdit(id: string) {
    const textContainer = this.trimDataManager.getText(id)
    if (!textContainer) return;
    const textData = TrimCjTool.getText(textContainer as TrimCjContainer);
    const step = textData.text ? 'edit' : 'create';
    if (!textData || step === 'create') {
      this.stage.stage.removeChild(textContainer);
      this.textBox = this.textBox.filter(v => v.textId !== textContainer.textId);
      this.trimDataManager.removeText(textContainer.textId ?? '')
      return;
    }
    if (!this.backupText || !this.backupText.text) {
      this.backupText = cloneDeep(textData);
      this.backupTextContainer = cloneDeep(textContainer);
      return;
    }
    const prevText = cloneDeep(textData);
    const prevTextContainer = cloneDeep(textContainer);
    this.editableEvent.action(
      'editText',
      `テキストを編集`,
      () => {
        if (!textData || !textContainer) return;
        textData.fontData = prevText.fontData;
        textData.options = prevText.options;
        textData.font = prevText.font;
        textContainer.fontName = prevTextContainer.fontName;
        textContainer.bold = prevTextContainer.bold;
        textContainer.italic = prevTextContainer.italic;
        textContainer.textSize = prevTextContainer.textSize;
        textContainer.text = prevText.text;
        textData.text = prevText.text;
        textData.alpha = prevText.alpha;
        textContainer.rotation = prevTextContainer.rotation;
        textData.color = prevText.color;
        textContainer.fontColor = prevText.color;
        textData.textAlign = prevText.textAlign;
        textContainer.horizontalAlignment = prevTextContainer.horizontalAlignment;
        textData.lineHeight = prevText.lineHeight;
        textContainer.lineHeight = prevTextContainer.lineHeight;
        // -- アウトライン設定時は複製して重ねる --
        if (prevText.options && prevText.options.outline) {
          if (TrimCjTool.checkOutline(textContainer)) {
            const prevOutline = TrimCjTool.getOutline(textContainer);
            textContainer.removeChild(prevOutline);
          }
          const outlineText = textData.clone();
          outlineText.mouseEnabled = false;
          outlineText.name = CJ_DPOBJ_NAME.outline;
          outlineText.outline = prevText.options.outline;
          textContainer.borderSize = String(prevText.options.outline);
          outlineText.color = prevText.options.outlineColor;
          textContainer.borderColor = prevText.options.outlineColor;
          textContainer.addChild(outlineText);
          textContainer.setChildIndex(textData, textContainer.numChildren - 1);
        } else {
          textContainer.borderSize = '0';
          textContainer.borderColor = '#ff0000';
          if (TrimCjTool.checkOutline(textContainer)) {
            const prevOutline = TrimCjTool.getOutline(textContainer);
            textContainer.removeChild(prevOutline);
          }
        }
        const textTfBounds = textData.getTransformedBounds();
        const hitArea = new TrimCjShape();
        hitArea.set({
          x: hitArea.x,
          y: hitArea.y,
          graphics: new TrimCjGraphics().f('#FFFFFF').dr(-(textData.margin), 0, textTfBounds.width, textTfBounds.height),
        });
        textData.hitArea = hitArea;
        this.fontType = prevText.options?.fontType ?? '';
        this.textEvent.updateFocus(textContainer);
        this.trimDataManager.setText(textContainer);
      },
      () => {
        if (!textData || !textContainer || !this.backupText || !this.backupTextContainer) return;
        textData.fontData = this.backupText.fontData;
        textData.options = this.backupText.options;
        textData.font = this.backupText.font;
        textData.text = this.backupText.text;
        textData.alpha = this.backupText.alpha;
        textContainer.text = this.backupText.text;
        textContainer.fontName = this.backupTextContainer.fontName;
        textContainer.bold = this.backupTextContainer.bold;
        textContainer.italic = this.backupTextContainer.italic;
        textContainer.textSize = this.backupTextContainer.textSize;
        textContainer.rotation = this.backupTextContainer.rotation;
        textData.color = this.backupText.color;
        textContainer.fontColor = this.backupText.color;
        textData.textAlign = this.backupText.textAlign;
        textData.lineHeight = this.backupText.lineHeight;
        textContainer.horizontalAlignment = this.backupTextContainer.horizontalAlignment;
        textContainer.lineHeight = this.backupTextContainer.lineHeight;
        if (this.backupText.options?.outline) {
          if (TrimCjTool.checkOutline(textContainer)) {
            const prevOutline = TrimCjTool.getOutline(textContainer);
            textContainer.removeChild(prevOutline);
          }
          const outlineText = textData.clone();
          outlineText.mouseEnabled = false;
          outlineText.name = CJ_DPOBJ_NAME.outline;
          outlineText.outline = this.backupText.options.outline;
          outlineText.color = this.backupText.options.outlineColor;
          textContainer.borderSize = String(this.backupText.options.outline);
          textContainer.borderColor = this.backupText.options.outlineColor;
          textContainer.addChild(outlineText);
          textContainer.setChildIndex(textData, textContainer.numChildren - 1);
        } else {
          textContainer.borderSize = '0';
          textContainer.borderColor = '#ff0000';
          if (TrimCjTool.checkOutline(textContainer)) {
            const prevOutline = TrimCjTool.getOutline(textContainer);
            textContainer.removeChild(prevOutline);
          }
        }
        if (this.backupText.options?.isShadow) {
          this.shadow = new TrimCjShadow(this.backupText.options!.shadowTransparency, this.backupText.options!.offset, this.backupText.options!.offset, 0);
          textData.shadow = this.shadow;
          textContainer.dropShadow = {
            enable: this.backupText.options.isShadow,
            transparence: this.backupText.options.shadowTransparency,
            virtualSize: this.backupText.options.offset,
          };
        } else {
          (textData.shadow as createjs.Shadow | null) = null;
          this.shadow = undefined;
          textContainer.dropShadow = {
            enable: false,
            transparence: 'rgba(0,0,0,0.65)',
            virtualSize: 7,
          };
          if (TrimCjTool.checkOutline(textContainer)) {
            const prevOutline = TrimCjTool.getOutline(textContainer);
            (prevOutline.shadow as createjs.Shadow | null) = null;
          }
        }
        this.fontType = 'server';
        this.trimDataManager.setText(textContainer);
        this.trimDataManager.setText(textContainer);
      },
    );
  }

  async restoreDo(text: TrimTextDataEntity, backup: TrimCjText) {
    return new Promise<void>(async (resolve) => {
      TrimUiManager.ins.emit('t->r:web-font:get-list', {
        callback: async (p) => {
          const edit = (fontName?: string) => {
            this.editText({
              id: backup.textId ?? '',
              text: text.value,
              color: ColorCodeConverter.Hex2Color(text.style.color),
              alpha: 1,
              rotation: text.rotate/100,
              textAlign: this.getTextAlign(text.alignment),
              lineHeight: 0,
              font: {
                isBold: text.style.bold ? 'bold' : '',
                isItalic: text.style.italic ? 'italic' : '',
                size: text.point/10 + 'pt',
                family: fontName ? fontName : text.font,
                // family: text.font,
              },
              options: {
                fontType: 'server',
                isShadow: false,
                shadowTransparency: `rgba(0, 0, 0, 0)`,
                offset: 0,
                outlineColor: ColorCodeConverter.Hex2Color(text.style.outline.color),
                outline: 0
                // outline: text.style.outline.width,
              }
            }, backup, true);
          }
          TrimUiManager.ins.emit('t->r:web-font:download', {
            fontFamilyName: text.font,
            callback: () => {
              edit(text.font);
              resolve();
            },
            error: (msg: string) => {
              alert('フォントの読み込みに失敗しました。');
            },
          });
        },
      });
    });
  }

  async createDateText() {
    const print = this.printManager.currentPrint;
    const dateText = print?.base.getDateTextWindow();
    const base = print?.base.getImageWindow();
    const image = this.printManager.editableImage;

    if (dateText?.object?.text?.value && base) {
      const text = dateText.object.text;
      this.textData.y = dateText?.virtual.pos.y ?? 0;
      this.textData.x = dateText?.virtual.pos.x ?? 0;
      const textId = `text:${UuidGenerator.create()}`;
      const textContainer = await this.addText(textId,true);
      const cjText = TrimCjTool.getDateText(textContainer);
      const backup = lodash.cloneDeep(cjText);
      this.editText({
        id: backup.textId ?? '',
        text: text.value,
        color: text.style.color,
        alpha: 1,
        rotation: 0,
        textAlign: this.getTextAlign(text.style.alignment),
        lineHeight: 0,
        font: {
          isBold: text.style.bold ? 'bold' : '',
          isItalic: text.style.italic ? 'italic' : '',
          size: text.point/10 + 'pt',
          family: text.font,
          // family: text.font,
        },
        options: {
          fontType: 'server',
          isShadow: false,
          shadowTransparency: `rgba(0, 0, 0, 0)`,
          offset: 0,
          outlineColor: text.style.outline.color,
          // outline: 0,
          // outline: text.style.outline.width,
          outline: PixelConverter.mmToPx(text.style.outline.width, PixelConverter.CSS_DPI) * 2,
        }
      }, backup, true, true);
    }
    // if (this.orderPage && this.orderPage.viewModel.orderText) {
    //   for (const orderText of this.orderPage?.viewModel.orderText?.data || []) {
    //     this.textData.y = Number(orderText.textRect?.virtual?.y ?? 0);
    //     this.textData.x = Number(orderText.textRect?.virtual?.x ?? 0);
    //     const textContainer = await this.addText();
    //     const text = TrimCjTool.getText(textContainer);
    //     const backup = lodash.cloneDeep(text);
    //     await this.restoreDo(orderText, backup);
    //   }
    // }
  }

  async restoreText() {
    const texts = this.printManager.printTrimData?.texts ?? [];
    for (const text of texts) {
      const textView = this.printManager.printTrimData?.view.texts.find(v => v.id === text.id);
      this.textData.y = textView ? textView.pos.y : (PixelConverter.mmToPx(text.y) ?? 0);
      this.textData.x = textView ? textView.pos.x : (PixelConverter.mmToPx(text.x) ?? 0);
      const textId = text.id ?? `text:${UuidGenerator.create()}`
      const textContainer = await this.addText(textId);
      const _text = TrimCjTool.getText(textContainer);
      const backup = lodash.cloneDeep(_text);
      await this.restoreDo(text, backup);
    }
  }

}
